import { createI18n } from 'vue-i18n';

const messages = {
  cn: {
    error: "参数错误",
    cancel: "取消",
    choose: "请选择",
    input: "请输入",
    required: "此字段是必需的",
    notfound: "未查询到订单信息，请确保订单号输入正确",
    used: "订单已被提交处理，不能重复提交，请在之前页面中继续完成支付；无法操作时，请重新下单。",
    complete: "完成",
    search: "搜索",
    back: "返回",
    prev: "上一步",
    next: "下一步",
    confirm: "提交",
    tips: "提示",
    yes: "我知道了",
    paid: "我已付款",
    create: "创建订单",
    tc: "条款和条件",
    remeber: "记住我",
    defray: {
      title: '快捷支付',
      total: '合计',
      content: '选择一种常用加密货币并扫码用钱包支付',
      blockchain: '链网络',
      paymentType: "支付方式",
      fill: "补充信息",
      cancel: '取消付款',
      send: '在 {net} 网络上发送 {coin}',
      desc: '打开您的数字钱包， 扫描二维码，或复制下面的 {coin} 地址，进行付款。',
      address: '地址',
      copy: '复制',
      copied: '已复制到剪贴板',
      amount: '总金额',
      nopay: '未付款',
      order: '您的订单代码为：',
      caution: '我们持续监控着网络，但未曾检测到付款。如果您已付款，请通过 {mail} 联系商户。',
      tip1: '您只能向该地址充值{coin}（{blockchain}），否则无法找回资产！',
      tip2: '请在订单有效期内充值，否则将无法入账！',
      tip3: '完成付款后，您可以选择 "我已付款"，系统将在 1-3 分钟内更新订单信息。',
      copyright: "付款服务商为 Klickl Pay. 有问题请联系 {mail}",
      choose: "选择币种支付",
      scan: "扫码完成付款",
      scanTip: "使用 {name} 扫码完成付款",
      paymentCode: "支付码",
      remark: "支付兑换汇率由 {brand} 系统提供，以下支付金额仅供参考，以实际支付汇率为准",
      open: "打开您的钱包，扫码付款",
      pay: '支付',
      toPay: "去支付",
      fiat: "法币",
      crypto: "数字货币",
      momo: '请检查您的手机，查看短信，根据提示完成付款',
      orderNo: "订单号",
      businessName: "商户名称",
      productName: "产品名称",
      time: "时间",
      orderDetail: "订单详情",
      information: "填写信息",
      expired: "链接已过期",
      expiredTip: "当前链接无效，请联系商家确认",
      yourName: "* 你的名称",
      phoneNumber: "* 手机号码",
      email: "* 邮箱",
      remarks: "备注 (可选)",
      processing: "付款处理中",
      details: [
        "1. 如果您已成功支付订单款项，系统将在 1-3 分钟内确认您的资金状态",
        "2. 在此期间，您可以选择继续留在此页面查看状态更新或关闭页面",
        "3. 订单完成后，我们将发送电子邮件通知您"
      ],
      closePage: "关闭页面",
      status: {
        title: "支付状态",
        success: {
          title: "成功",
          desc: "感谢您，您的支付已完成！"
        },
        fail: {
          title: "失败",
          desc: "我们持续监控着网络，但未曾检测到付款"
        },
        cancel: {
          title: "取消",
          desc: "取消支付，您的支付已取消"
        },
        pending: {
          title: "支付中",
          desc: "支付正在进行中，我们持续监控着网络，请在打开的页面中完成操作。"
        }
      },
      dynamic: {
        supplier: "运营商",
        bank_account_holder_name: '银行账户持有人姓名',
        iban: 'IBAN',
        account_name: "账户名称",
        account_number: '账号',
        sort_code: '排序代码',
        aba: 'ABA',
        blz_code: 'BLZ代码',
        branch_code: '分行代码',
        bsb_code: 'BSS代码',
        ifs_code: 'IFS代码',
        clabe_code: 'CLABE代码',
        ctn: 'CTN',
        cpf: 'CPF',
        bank_name: '银行名称',
        bank_address: '银行地址',
        bank_city: '银行城市',
        bank_postal_code: '银行邮政编码',
        bic: 'BIC',
        beneficiary_address_line: '受益人地址',
        beneficiary_city: '受益人城市',
        beneficiary_postal_code: '受益人邮政编码',
        phone_number: '手机',
        taxId: '税号',
        branch_number: '分行号',
        owner_document_number: '所有者文件编号',
        owner_name: '所有者名称',
        bank_code: '银行代码',
        bank_number: '银行卡号',
        swift_code: 'Swift代码',
        expiration_date: '有效期',
        brand: '品牌',
        id_card: "ID Card",
        security_code: '安全代码',
        bank_account_type: '银行账户类型',
        national_id: "National Id (CPF/CNPJ)",
        email: "邮箱",
        pix_key: "PIX Key",
        address: "地址",
        payToAccount: "打款至以下账号",
        accountNumber: "账户号码",
        paymentCode: "支付码",
        vaNumber: "VA 卡号",
        orderNo: "订单号",
        email_address: "邮箱地址",
        bankName: "银行名称",
        bankCode: "银行编码",
        beneficiaryName: "受益人名称",
        bankAccount: "银行账号",
        referenceNumber: "参考编号",
        bankAccountType: "银行账户类型",
        accountId: "账户 ID"
      },
    },
    cashier: {
      time: '{s}秒后更新报价',
      h1: "收银台",
      payin: '完成付款{br}只需简单几步',
      payout: "完成收款{br}只需简单几步",
      fee: '手续费',
      total: '金额',
      payment: '选择支付方式',
      paytype: '选择支付类型',
      datetime: "选择日期",
      expiryDate: "有效期",
      cvv: "安全码",
      payinfo: '付款信息',
      qrcode: '二维码支付',
      back: '返回',
      cancel: '取消付款',
      send: '在 {net} 网络上发送 {coin}',
      desc: '输入信息完成付款',
      copy: '复制',
      copied: '已复制到剪贴板',
      amount: '总金额',
      order: '您的订单代码为：',
      caution: '我们持续监控着网络，但未曾检测到付款。如果您已付款，请通过 {mail} 联系商户。',
      tip1: '通过全球无缝支付功能实现{br}全球支付功能',
      tip2: '请在订单有效期内充值，否则将无法入账！',
      copyright: "付款服务商为 Klickl Pay. 有问题请联系 {mail}",
      scan: "扫码支付",
      remark: "支付兑换汇率由 Klick Pay 系统提供，以下支付金额仅供参考，以实际支付汇率为准",
      open: "打开您的钱包，扫码付款",
      pay: "支付",
      next: "下一步",
      link: "支付链接",
      validity: "校验账户失败",
      other: "其它",
      supplier: "运营商",
      phone: "手机号",
      phoneTip: "请输入手机号（含区号）",
      phoneNumber: "手机号",
      bank: "银行",
      bankNumber: "银行卡号",
      cardHolderName: '持卡人姓名',
      cardNumber: "卡号",
      accountName: "账户名称",
      accountNumber: "账户号码",
      address: "地址",
      paymentCode: "支付码",
      vaNumber: "va卡号",
      orderNo: "订单号",
      channel: "通道",
      paymentType: "支付类型",
      orderTime: "订单时间",
      paid: "我已完成付款",
      processing: "支付中",
      error: "调用异常，请重试",
      embedBlocked: "当前页面不允许在此站点内嵌打开，请通过商户官方页面完成支付。",
      pending: "提交申请单成功",
      useBank: "使用银行（{name}）扫码完成付款",
      useQRIS: "使用电子钱包（{name}）扫码完成付款",
      payToAccount: "打款至以下账号",
      nationalId: "National Id (CPF/CNPJ)",
      email: "邮箱",
      pixKey: "PIX Key",
      jcb: "不支持 JCB 卡",
      amex: "不支持美国运通卡",
      china: "不支持中国银联",
      mada: "不支持 Mada 卡",
      incomplete: "卡号不完整",
      expiry: '有效期已过',
      type: {
        MOMO: "手机认证",
        BANK: "银行",
        OVO: "OVO",
        DIRECT: "银行直连",
        QRIS: "二维码",
        DANA: "DANA",
      },
      PayinStatus: {
        0: "预下单",
        1: "支付中",
        2: "支付成功",
        3: "支付失败",
        4: "支付取消",
        5: "订单异常",
        6: "订单关闭",
      },
      PayoutStatus: {
        0: "预下单",
        1: "审核中",
        2: "审核中",
        3: "审核中",
        4: "审核中",
        5: "提现成功",
        6: "提现失败",
        7: "拒绝",
        8: "支付取消"
      }
    },
    example: {
      t001: "沙盒环境",
      t002: "重定向示例页面",
      t003: "1. 在沙箱环境中，不会创建真实交易。当 {type} 为 {action} 时，将重定向回本页面。",
      t004: "ACTION_TYPE",
      t005: "REDIRECT",
      t006: "2. 在生产环境中，当交易发起时，将返回真实业务地址。",
    }
  },
  en: {
    error: "Params Error",
    cancel: "Cancel",
    choose: "Choose",
    input: "Please input ",
    required: "This field is required",
    notfound: "The order information was not found, please ensure that the order number is entered correctly",
    used: "The order has been submitted for processing and cannot be resubmitted, please continue to complete the payment in the previous page; if you are unable to do so, please place a new order.",
    complete: "Complete",
    search: "Search",
    back: "Back",
    prev: "Previous",
    next: "Next",
    confirm: "Confirm",
    tips: "Tips",
    yes: "Ok",
    paid: "I Have Paid",
    create: "Create Order",
    tc: "Terms & Conditions",
    remeber: "Remember me",
    defray: {
      title: 'Quick Payment',
      total: 'Total',
      content: 'Choose a common cryptocurrency and scan the QR code to pay with your wallet',
      blockchain: 'Select Network',
      paymentType: "Payment Type",
      fill: 'Additional Information',
      cancel: 'Cancel Payment',
      send: 'Send {coin} on the {net} network',
      desc: 'Open your digital wallet, scan the QR code, or copy the {coin} address below to make a payment.',
      address: 'Address',
      copy: 'Copy',
      copied: 'Copied to clipboard',
      amount: 'Total Amount',
      nopay: 'Unpaid',
      order: 'Your Order Code:',
      caution: 'We continue to monitor the network, but no payments have been detected. If you have already paid, please contact the merchant at {mail}.',
      tip1: 'You can only recharge {coin} ({blockchain}) to this address, otherwise the assets cannot be retrieved !',
      tip2: 'Please recharge within the validity period of the order, otherwise it will not be credited !',
      tip3: 'After completing the payment, you can choose “I Have Paid,”, and the system will update the order information within 1-3 minutes.',
      copyright: "The payment service provider is Klickl Pay. Please contact {mail} if you have any questions",
      choose: "Choose Payment Currency",
      scan: "Scan the Code to Pay",
      scanTip: "Use the {name} to scan the code to complete the payment",
      paymentCode: "Payment Code",
      remark: "The payment exchange rate is provided by the {brand} system, the following payment amount is for reference only, and the actual payment exchange rate shall prevail",
      open: "Open your wallet, scan the QR code to pay",
      pay: 'Pay',
      toPay: "To Payment",
      fiat: "Fiat",
      crypto: "Crypto",
      momo: 'Please check your mobile phone for SMS alerts to complete the payment process!',
      orderNo: "Order Number",
      businessName: "Business Name",
      productName: "Product Name",
      time: "Time",
      orderDetail: "Order Detail",
      information: "Fill In the Information",
      expired: "Link has expired !",
      expiredTip: "The current link is invalid, please contact the merchant to confirm",
      yourName: "* Your Name",
      phoneNumber: "* Phone Number",
      email: "* Email",
      remarks: "Remark (optional)",
      processing: "Payment Processing in Progress",
      details: [
        "1. If you have successfully paid for your order, the system will confirm the status of your funds within 1 - 3 minutes.",
        "2. During this time, you can choose to remain on this page for status updates or close the page.",
        "3. An email notification will be sent to inform you when your order is complete"
      ],
      closePage: "Close Page",
      status: {
        title: "Payment Status",
        success: {
          title: "Success",
          desc: "Your payment has been completed"
        },
        fail: {
          title: "Fail",
          desc: "We are continuously monitoring the network but no payment has been detected"
        },
        cancel: {
          title: "Cancel",
          desc: "Your payment has been cancelled"
        },
        pending: {
          title: "Pending",
          desc: "Payment is in progress, we are constantly monitoring the network, please complete the operation on the page that opens."
        }
      },
      dynamic: {
        supplier: "Supplier",
        bank_account_holder_name: 'Bank Account Holder Name',
        iban: 'IBAN',
        account_name: "Account Name",
        account_number: 'Account Number',
        sort_code: 'Sort Code',
        aba: 'ABA',
        blz_code: 'BLZ Code',
        branch_code: 'Branch Code',
        bsb_code: 'BSB Code',
        ifs_code: 'IFS Code',
        clabe_code: 'CLABE Code',
        ctn: 'CTN',
        cpf: 'CPF',
        bank_name: 'Bank Name',
        bank_address: 'Bank Address',
        bank_city: 'Bank City',
        bank_postal_code: 'Bank Postal Code',
        bic: 'BIC',
        beneficiary_address_line: 'Beneficiary Address Line',
        beneficiary_city: 'Beneficiary City',
        beneficiary_postal_code: 'Beneficiary Postal Code',
        phone_number: 'Phone Number',
        taxId: 'Tax ID',
        branch_number: 'Branch Number',
        owner_document_number: 'Owner Document Number',
        owner_name: 'Owner Name',
        bank_code: 'Bank Code',
        bank_number: 'Bank Number',
        swift_code: 'Swift Code',
        expiration_date: 'Expiration Date',
        brand: 'Brand',
        security_code: 'Security Code',
        bank_account_type: 'Bank Account Type',
        id_card: "ID Card",
        national_id: "National Id (CPF/CNPJ)",
        email: "Email",
        pix_key: "PIX Key",
        address: "Address",
        payToAccount: "Payment to the following account number",
        accountNumber: "Account Number",
        paymentCode: "Payment Code",
        vaNumber: "VA Number",
        orderNo: "Order No.",
        email_address: "Email Address",
        bankName: "Bank Name",
        bankCode: "Bank Code",
        beneficiaryName: "Beneficiary Name",
        bankAccount: "Bank Account",
        referenceNumber: "Reference Number",
        bankAccountType: "Bank Account Type",
        accountId: "Account ID"
      },
    },
    cashier: {
      time: 'Update quote in {s} seconds',
      h1: "Checkout",
      payin: 'Complete Payment {br} Just a Few Steps',
      payout: "Complete Collection {br} Just a Few Steps",
      fee: 'Fee',
      total: 'Amount',
      payment: 'Choose Payment Style',
      paytype: 'Choose Payment Type',
      datetime: "Choose Date",
      expiryDate: "Expiry Date",
      cvv: "Security Code",
      payinfo: 'Payment Info',
      qrcode: 'Scan QR Code to complete payment',
      back: 'Back',
      cancel: 'Cancel Payment',
      send: 'Send {coin} on the {net} network',
      desc: 'Enter to Complete Payment',
      copy: 'Copy',
      copied: 'Copied to clipboard',
      amount: 'Total Amount',
      order: 'Your Order Code:',
      caution: 'We continue to monitor the network, but no payments have been detected. If you have already paid, please contact the merchant at {mail}.',
      tip1: 'Enable global payment functionality through seamless payment capabilities across the globe',
      tip2: 'Please recharge within the validity period of the order, otherwise it will not be credited !',
      copyright: "The payment service provider is Klickl Pay. Please contact {mail} if you have any questions",
      scan: "Scan the Code to Pay",
      remark: "The payment exchange rate is provided by the Klick Pay system, the following payment amount is for reference only, and the actual payment exchange rate shall prevail",
      open: "Open your wallet, scan the QR code to pay",
      pay: 'Pay',
      next: 'Next',
      link: "Payment Link",
      validity: "Verify Account Failed",
      other: "Other",
      supplier: "Supplier",
      phone: "Phone Number",
      phoneTip: "Input phone number (with country code)",
      phoneNumber: "Phone Number",
      bank: "Bank",
      bankNumber: "Bank Number",
      cardHolderName: 'Card Holder Name',
      cardNumber: "Card Number",
      accountName: "Account Name",
      accountNumber: "Account Number",
      address: "Address",
      paymentCode: "Payment Code",
      vaNumber: "VA Number",
      orderNo: "Order No.",
      channel: "Payment With",
      paymentType: "Payment Type",
      orderTime: "Order Time",
      paid: "I have made the payment",
      processing: "Payment Processing",
      error: "Call exception, Please try again",
      embedBlocked: "This payment page cannot be embedded on this site. Please open it from the merchant’s official page.",
      pending: "Submit the application form successfully",
      useBank: "Use the bank ({name}) to scan the code to complete the payment",
      useQRIS: "Use the electronic wallet ({name}) to scan the code to complete the payment",
      payToAccount: "Payment to the following account number",
      nationalId: "National Id (CPF/CNPJ)",
      email: "Email",
      pixKey: "PIX Key",
      jcb: "JCB not supported",
      amex: 'Amex not supported',
      china: 'China Union Pay not supported',
      mada: 'Mada not supported',
      incomplete: 'Card number is incomplete',
      expiry: 'Expiry date is in the past',
      type: {
        MOMO: "Mobile Authentication",
        BANK: "Bank",
        OVO: "OVO",
        DIRECT: "Direct Bank",
        QRIS: "QR Code",
        DANA: "DANA",
      },
      PayinStatus: {
        0: "Pre Order",
        1: "Payment Processing",
        2: "Payment Success",
        3: "Payment Fail",
        4: "Payment Cancel",
        5: "Order Abnormal",
        6: "Order Close",
      },
      PayoutStatus: {
        0: "Pre Order",
        1: "Pending",
        2: "Pending",
        3: "Pending",
        4: "Pending",
        5: "Success",
        6: "Fail",
        7: "Reject",
        8: "Payment Cancel",
      }
    },
    example: {
      t001: "Sandbox Environment",
      t002: "Redirect Example Page",
      t003: "1. In the sandbox environment, no actual transactions are created. When the {type} is {action} it will redirect back to this page.",
      t004: "ACTION_TYPE",
      t005: "REDIRECT",
      t006: "2. In the production environment, when a transaction is initiated, the actual transaction address will be returned.",
    }
  },
};

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  legacy: false,
  fallbackWarn: false,
  globalInjection: true,
  messages
});

export default i18n;
